import * as z from "zod";

/** A GitHub event a waiting session resumes on, e.g. the merge of `acme/web#42`. */
export type AwaitedGithubEvent = z.infer<typeof AwaitedGithubEvent>;
export const AwaitedGithubEvent = z.object({
  /** The wait's id, which cancels it. */
  id: z.string(),
  repository: z.string(),
  pr_number: z.number(),
  url: z.string(),
});
